import React from "react";
import theme from "@/styles/theme";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import SvgIcon from "@mui/material/SvgIcon";
import Link from "@mui/material/Link";
import {
  AmazonmusicIcon,
  ApplemusicIcon,
  BandcampIcon,
  DeezerIcon,
  SoundcloudIcon,
  SpotifyIcon,
  TiktokIcon,
} from "@/components/icons";
import FacebookRoundedIcon from "@mui/icons-material/FacebookRounded";
import TwitterIcon from "@mui/icons-material/Twitter";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import HomeIcon from "@mui/icons-material/Home";
import LinkStyled from "./LinkStyled";

export const LinkCollection = ({band, ...props}) => {
  return <>
    <Grid
      container
      justifyContent="center"
      spacing={0}
      sx={{
        "& .MuiIconButton-root:hover": {
          "& svg": {
            fill: theme.palette.primary.main,
          },
        },
      }}
    >
      {band.link_website && (
        <Grid item xs="auto">
          <Link
            href={band.link_website}
            target="_blank"
            rel="noopener noreferrer"
          >
            {band.link_website.replace(/https:\/\//gi, "")}
          </Link>
        </Grid>
      )}
      <Grid item xs={12}>
        {band.link_facebook && (
          <Link
            href={band.link_facebook}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton color="secondary">
              <FacebookRoundedIcon sx={{fontSize: 32}} />
            </IconButton>
          </Link>
        )}
        {band.link_instagram && (
          <Link
            href={band.link_instagram}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton color="secondary">
              <InstagramIcon sx={{fontSize: 32}} />
            </IconButton>
          </Link>
        )}
        {band.link_youtube && (
          <Link
            href={band.link_youtube}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton color="secondary">
              <YouTubeIcon sx={{fontSize: 32}} />
            </IconButton>
          </Link>
        )}
        {band.link_twitter && (
          <Link
            href={band.link_twitter}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton color="secondary">
              <TwitterIcon sx={{fontSize: 32}} />
            </IconButton>
          </Link>
        )}
        {band.link_tiktok && (
          <Link
            href={band.link_tiktok}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <TiktokIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
        {band.link_soundcloud && (
          <Link
            href={band.link_soundcloud}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <SoundcloudIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
        {band.link_bandcamp && (
          <Link
            href={band.link_bandcamp}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <BandcampIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
        {band.link_spotify && (
          <Link
            href={band.link_spotify}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <SpotifyIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
        {band.link_applemusic && (
          <Link
            href={band.link_applemusic}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <ApplemusicIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
        {band.link_deezer && (
          <Link
            href={band.link_deezer}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <DeezerIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
        {band.link_amazonmusic && (
          <Link
            href={band.link_amazonmusic}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IconButton>
              <SvgIcon
                color="secondary"
                sx={{
                  fontSize: 32,
                  color: theme.palette.secondary.main,
                }}
              >
                <AmazonmusicIcon />
              </SvgIcon>
            </IconButton>
          </Link>
        )}
      </Grid>
    </Grid>
  </>;
};
